// image-product-detail-v2 Cuando acabe el test, o veamos que pasa, eliminar este evento
import {BIModel} from './BIModel.js';

export class CarouselScrollBIModel extends BIModel {
  static eventName = 'swipe';

  #action;
  #id;
  #countrySeller;

  constructor(userId, action, id, countrySeller) {
    super(CarouselScrollBIModel.eventName, userId);
    this.#action = action;
    this.#id = id;
    this.#countrySeller = countrySeller;
  }

  get action() {
    return this.#action;
  }

  get id() {
    return this.#id;
  }

  get modelData() {
    return {
      action: this.action,
      id: this.id,
      country_seller: this.#countrySeller
    };
  }

}